module.exports = __webpack_public_path__ + "static/media/angle-left-white.14fe3165.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/angle-left-white.svg
 ** module id = 871
 ** module chunks = 0
 **/